import { appointmentDummyData, PatientData } from '../../../../../core/types/dashboard.model';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { Avatar } from 'primeng/avatar';
import { Calendar, CalendarModule } from 'primeng/calendar';
import { Button } from 'primeng/button';
import { AppoimentService } from '../appoinment-services/appoiment.service';
import { DoctorSlot } from '../appoinment-const/appoinment-model';
import { ConsultationType } from '../appoinment-const/appoinment-enum';
import { LocalStorageService } from 'projects/patient/src/app/core/auth/services/local-storage.service';
import { PreAssesmentComponent } from '../pre-assesment/pre-assesment.component';
import { AuthService } from 'projects/patient/src/app/core/auth/services/auth.service';
import { Paging } from 'projects/patient/src/app/core/types/helper.model';
import { PaymentSummuryComponent } from '../payment-summury/payment-summury.component';

@Component({
  selector: 'patient-create-appoinment',
  imports: [
    Avatar,
    Calendar,
    CommonModule,
    Button,
    CalendarModule,
    FormsModule,
    PreAssesmentComponent,
    PaymentSummuryComponent,
  ],
  templateUrl: './create-appoinment.component.html',
  styleUrl: './create-appoinment.component.css',
})
export class CreateAppoinmentComponent {
  userName: string = 'Dummy User';
  userInitials: string = '';
  form!: FormGroup;
  showSummury: boolean = false;
  showAppointment: boolean = true;

  localStorageService = inject(LocalStorageService);

  appointmenData!: {
    selectedDate?: string;
    selectedType?: number;
    selectedSlotId?: string;
    selectedSlot?: string;
    doctorId?: string;
    userId?: string;
    userName?: string;
    PatientId?: string;
    doctorFee?: string;
    DoctorName?: string;
    assessmentID?: string;
    questionnaireId?: string;
    reportUrl?: string;
  };

  user: any = {};

  ConsultationType = ConsultationType;

  selectedDate: Date = new Date();

  availableSlots: DoctorSlot[] = [];

  doctorDetails!: {
    doctorFee: string;
    DoctorName: string;
  };

  minDate!: Date;
  selectedSlotId: any = null;
  selectedSlot: any = null;
  selectedType!: ConsultationType;
  doctorId: string = '0f6a2911-3092-47f7-bda5-e5da8f032726';

  private _appointmentService = inject(AppoimentService);
  authService = inject(AuthService);

  assessmentDetails: any;

  constructor(private fb: FormBuilder) {}

  paging: Paging = {
    pageSize: 10,
    pageNumber: 1,
  };

  ngOnInit(): void {
    const state = history.state;

    if (state?.assessmentDetails) {
      const assessmentDetails = state.assessmentDetails;
      this.assessmentDetails = assessmentDetails;
      console.log(this.assessmentDetails, 'assessment details in create appointment component');
    }

    this.minDate = new Date();
    this.minDate.setHours(0, 0, 0, 0);
    this.getAppoinmnetSlot();
    this.authService.getUserProfile().subscribe((res) => {
      ((this.user.patientID = res.PatientId),
        (this.user.userId = res.user_id),
        (this.user.userName = res.unique_name));
    });
    this.getDoctorFee(this.paging);

    // 👇 Load for default today
    // this.loadSlots(today);
  }

  onDateChange(date: Date) {
    this.getAppoinmnetSlot();
  }

  selectSlot(slot: DoctorSlot) {
    this.selectedSlotId = slot.id;
    this.selectedSlot = slot.slot_time;
    console.log('Selected Slot ID:', slot.id);
  }

  selectType(type: ConsultationType) {
    this.selectedType = type;
    console.log(this.selectedType);
  }

  getAppoinmnetSlot() {
    const formattedDate = this.selectedDate.toISOString().split('T')[0];

    console.log(formattedDate);

    this._appointmentService.getAppoinentSlot(this.doctorId, formattedDate).subscribe({
      next: (res) => {
        this.availableSlots = res.data;
      },
      error: (err) => {
        console.warn(err);
      },
    });
  }

  getDoctorFee(data: Paging) {
    let filters: string[] = [];

    if (this.doctorId) {
      // filters.push(`doctor_id eq ${this.doctorId}`);
      filters.push(`service_type eq 'FirstAppointment'`);
    }
    data.filter = filters.join(' and ');

    this._appointmentService.getDoctorFee(data).subscribe({
      next: (res) => {
        const data = res.data[0];
        this.doctorDetails = {
          doctorFee: data.fee_amount,
          DoctorName: data.doctor_name,
        };
        console.log(this.doctorDetails);
      },

      error: (err) => {},
    });
  }

  submitAppointment() {
    const formattedDate = this.selectedDate.toISOString().split('T')[0];
    this.appointmenData = {
      selectedDate: formattedDate,
      selectedType: this.selectedType,
      selectedSlotId: this.selectedSlotId,
      selectedSlot: this.selectedSlot,
      doctorId: this.doctorId,
      userId: this.user.userId,
      PatientId: this.user.patientID,
      userName: this.user.userName,
      doctorFee: this.doctorDetails.doctorFee,
      DoctorName: this.doctorDetails.DoctorName,
      assessmentID: this.assessmentDetails?.assessmentID,
      reportUrl: this.assessmentDetails?.reportUrl,
    };
    console.log(this.appointmenData);
    this.showSummury = true;
    this.showAppointment = false;
  }

  // startAssessment() {
  //   this.showPreAssesmentQue = true;
  //   this.showPreassement = false;
  // }
}
